export default __webpack_public_path__ + "static/media/trunamoy-dentin-legende.dd821b38.svg";